import { useEffect } from 'react'
import { Action } from 'redux'

import { SmDisruptionMessage } from '@/src/types/Input'

import { useTypedDispatch } from '../..'
import { fetchSmDisruptionsAction } from '../../actions/sm-disruptions'
import { dismissSmDisruptionsNotification } from '../../reducers/smDisruptionSlice'
import { SmDisruptionNotification } from './SmDisruptionNotification'

type Props = {
  activeMessage: SmDisruptionMessage | null
  fetchHistory?: boolean
  closable?: boolean
}

export const SmDisruptionNotificationContainer = ({
  activeMessage,
  fetchHistory = false,
  closable = true,
}: Props) => {
  const dispatch = useTypedDispatch()
  useEffect(() => {
    if (fetchHistory) {
      dispatch(fetchSmDisruptionsAction())
    }
  }, [dispatch, fetchHistory])

  const dismissSmDisruptions = () => {
    dispatch(dismissSmDisruptionsNotification() as unknown as Action)
  }

  return (
    <>
      {!!activeMessage && (
        <SmDisruptionNotification
          title={activeMessage.title}
          body={activeMessage.body}
          onClose={closable ? dismissSmDisruptions : undefined}
        />
      )}
    </>
  )
}
